// extracted by mini-css-extract-plugin
export default {"badge":"hLbXGXVX1UQQcYw9dQNU","button":"FPBpx4GMJNOIyv6s36tQ"};